import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import ordersDetailsData from "./data/orderDetailsData"
import AccessCodeService from "services/AccessCodeService";

function OrdersDetails() {
  const { id } = useParams();
  const accessCode = AccessCodeService.getOrderAccessCode(id);

  const data = ordersDetailsData(id, accessCode);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    Detalhes do pedido
                  </MDTypography>
                </MDBox>
              </MDBox>
              {data}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default OrdersDetails;
